export default __webpack_public_path__ + "static/media/prize-4-cn.ad138a75.webp";